import React, { useState, useEffect } from "react";
import { Button, Divider, Grid, MenuItem, Typography } from "@mui/material";
import CustomTextField from "src/components/forms/theme-elements/CustomTextField";
import CustomFormLabel from "src/components/forms/theme-elements/CustomFormLabel";
import ParentCard from "src/components/shared/ParentCard";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import { useFormik } from "formik";
import * as yup from "yup";
import { useNavigate, useParams } from "react-router";
import DeviceService from "src/service/device";
import swal from "sweetalert";
import CustomSelect from "src/components/forms/theme-elements/CustomSelect";
import { IconArrowBack } from "@tabler/icons";
import DeviceModelService from "src/service/devicemodel";
const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: "Update Device",
  },
];

const validationSchema = yup.object({
  imei_no: yup
    .string("Enter Imei No")
    .matches(/^[0-9]{10,20}$/, "Invalid Imei no")
    .required("Imei no is Required"),

  serial_no: yup
    .string("Enter Serial No")
    .matches(/^[0-9]{10,20}$/, "Invalid Imei no")
    .required("Serial no is Required"),
});

const UpdateDevice = () => {
  const sessionData = JSON.parse(localStorage.getItem("user"));
  const param = useParams();
  // eslint-disable-next-line no-unused-vars
  const [deviceModel, setdeviceModel] = React.useState("");
  // const [devicemodel_name, setDeviceModel_name] = useState([]);

  const navigate = useNavigate();

  // const handledevicetype = (event) => {
  //   setdeviceModel(event.target.value);
  // };

  const [initialValues, setInitialValues] = useState({
    id: param.id,
    imei_no: "",
    serial_no: "",
    device_type: "",
    c_by: sessionData.data.id,
  });

  const fetchDeviceModelData = async () => {
    try {
      const res = await DeviceModelService.getDeviceModel({
        manufacturer_id: sessionData.data.id,
      });
      // setDeviceModel_name(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const fetchDeviceData = async () => {
      try {
        const res = await DeviceService.getDevice({
          id: param.id,
        });

        setInitialValues({
          id: param.id,
          imei_no: res.data[0].imei_no,
          serial_no: res.data[0].serial_no,
          device_type: res.data[0].device_type,
          d_by: sessionData.data.id,
        });
      } catch (error) {
        console.log(error);
      }
    };
    fetchDeviceData();
  }, [param.id, sessionData.data.id, sessionData.data.user_type]);

  useEffect(() => {
    fetchDeviceModelData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionData.data.id, sessionData.data.user_type]);

  const { values, errors, touched, handleChange, handleBlur, handleSubmit } =
    useFormik({
      enableReinitialize: true,
      initialValues: initialValues,
      validationSchema: validationSchema,
      onSubmit: async (values) => {
        // alert(JSON.stringify(values, null, 2));

        try {
          const res = await DeviceService.updateDevice(values);
          swal("success", res.message, "success");
          setTimeout(() => {
            navigate("/device");
          }, 1000);
        } catch (error) {
          swal("error", error, "error");
        }
      },
    });

  // =============================

  return (
    <div>
      <Breadcrumb title="Update Device" items={BCrumb} />
      <ParentCard title="">
        <Grid container alignItems="center">
          <Grid
            item
            xs={4}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Typography
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
              }}
              variant="h2"
            >
              Update Device
            </Typography>
          </Grid>

          <Grid
            item
            xs={8}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                navigate("/device");
              }}
            >
              <IconArrowBack width={20} />
            </Button>
          </Grid>
        </Grid>
        <Divider />

        <form onSubmit={handleSubmit}>
          <Grid container spacing={3} style={{ marginTop: "0px" }}>
            {/*   ==== Imei No  -===  */}

            <Grid
              item
              lg={6}
              md={6}
              sm={6}
              xs={12}
              style={{ marginTop: "-10px" }}
            >
              <CustomFormLabel htmlFor="imei_no">
                Imei No. <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="imei_no"
                name="imei_no"
                type="text"
                value={values.imei_no}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.imei_no && Boolean(errors.imei_no)}
                helperText={touched.imei_no && errors.imei_no}
                variant="outlined"
                placeholder="Enter Imei No."
                fullWidth
              />
            </Grid>
            {/*   ====  device type  -===  */}
            <Grid
              item
              lg={6}
              md={6}
              sm={6}
              xs={12}
              style={{ marginTop: "-10px" }}
            >
              <CustomFormLabel htmlFor="for_device_type">
                Device Type <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomSelect
                id="device_type"
                name="device_type"
                value={values.device_type}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.device_type && Boolean(errors.device_type)}
                fullWidth
                variant="outlined"
              >
                <MenuItem value="1">GPS</MenuItem>
                <MenuItem value="2">SOS Button</MenuItem>
                <MenuItem value="3">GPS with SOS Button</MenuItem>
              </CustomSelect>
            </Grid>
            <Grid
              item
              lg={6}
              md={6}
              sm={6}
              xs={12}
              style={{ marginTop: "-10px" }}
            >
              <CustomFormLabel htmlFor="serial_no">
                Serial No <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="serial_no"
                name="serial_no"
                type="text"
                value={values.serial_no}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.serial_no && Boolean(errors.serial_no)}
                helperText={touched.serial_no && errors.serial_no}
                variant="outlined"
                placeholder="Enter Serial No"
                fullWidth
              />
            </Grid>

            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Button color="primary" variant="contained" type="submit">
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </ParentCard>
    </div>
  );
};

export default UpdateDevice;
